// plugins/setup-ui.client.ts
import TinyMCE from "~/components/base/TinyMCE.vue";

export default defineNuxtPlugin(async (nuxtApp) => {
	// 1. 將所有大型套件改為非同步動態載入，徹底解決 Top-level TDZ 與拆包順序問題
	const [bootstrap, VueSmoothScroll, OpenLayers, draggable, VueDatePicker, QRCodeVue3, vCalendar, fontAwesomeVue, fontAwesomeCore, faSolid, faBrands, faRegular] = await Promise.all([
		import("bootstrap"),
		import("vue3-smooth-scroll"),
		import("vue3-openlayers"),
		import("vuedraggable"),
		import("@vuepic/vue-datepicker"),
		import("qrcode-vue3"),
		import("v-calendar"),
		import("@fortawesome/vue-fontawesome"),
		import("@fortawesome/fontawesome-svg-core"),
		import("@fortawesome/free-solid-svg-icons"),
		import("@fortawesome/free-brands-svg-icons"),
		import("@fortawesome/free-regular-svg-icons"),
	]);

	// 2. 處理 Bootstrap 實例並提供全局 Provider
	const bs = bootstrap.default || bootstrap;
	nuxtApp.provide("bootstrap", bs);

	// 3. 註冊 UI Vue 套件與組件
	nuxtApp.vueApp.use(VueSmoothScroll.default || VueSmoothScroll);
	nuxtApp.vueApp.use(OpenLayers.default || OpenLayers, { debug: false });

	nuxtApp.vueApp.component("draggable", draggable.default || draggable);
	nuxtApp.vueApp.component("Calendar", vCalendar.Calendar);
	nuxtApp.vueApp.component("DatePicker", vCalendar.DatePicker);
	nuxtApp.vueApp.component("VueDatePicker", VueDatePicker.default || VueDatePicker);
	nuxtApp.vueApp.component("QRCodeVue3", QRCodeVue3.default || QRCodeVue3);
	nuxtApp.vueApp.component("TinyMCE", TinyMCE);

	// 4. FontAwesome 設定
	fontAwesomeCore.config.autoAddCss = false;
	fontAwesomeCore.library.add(faSolid.fas, faBrands.fab, faRegular.far);
	nuxtApp.vueApp.component("font-awesome-icon", fontAwesomeVue.FontAwesomeIcon);
	nuxtApp.vueApp.component("font-awesome-layers", fontAwesomeVue.FontAwesomeLayers);
	nuxtApp.vueApp.component("font-awesome-layers-text", fontAwesomeVue.FontAwesomeLayersText);

	// 5. PWA 自動更新監聽
	const { $pwa } = useNuxtApp();
	if ($pwa) {
		watch($pwa.needRefresh, (needRefresh) => {
			if (needRefresh) {
				$pwa.updateServiceWorker(true);
			}
		});
	}

	// 6. 指令註冊：換行轉 <br>
	nuxtApp.vueApp.directive("tranBr", {
		mounted(el, binding) {
			if (binding.value) {
				el.innerHTML = String(binding.value).replace(/\n/g, "<br>");
			}
		},
		updated(el, binding) {
			if (binding.value !== binding.oldValue) {
				el.innerHTML = String(binding.value).replace(/\n/g, "<br>");
			}
		},
	});

	// 7. 指令註冊：Bootstrap Popover (修正 DOM 掛載順序與記憶體回收)
	nuxtApp.vueApp.directive("bsPopover", {
		mounted(el, binding) {
			if (bs && bs.Popover && binding.value) {
				// 在 mounted 確保 DOM 節點已存在，並直接呼叫閉包中的 bs 變數
				el._bsPopover = new bs.Popover(el, binding.value);
			}
		},
		updated(el, binding) {
			if (el._bsPopover && binding.value) {
				// 當傳入參數更新時同步更新 Popover
				el._bsPopover.setContent?.({
					".popover-body": binding.value.content || "",
				});
			}
		},
		unmounted(el) {
			// 元素銷毀時釋放 Bootstrap Popover 記憶體
			if (el._bsPopover) {
				el._bsPopover.dispose();
				delete el._bsPopover;
			}
		},
	});

	// 8. 指令註冊：圖片路徑處理 (移除廢棄的 Canvas 註解代碼)
	nuxtApp.vueApp.directive("imageSrc", {
		mounted(el, binding) {
			if (binding.value) el.src = binding.value;
		},
		updated(el, binding) {
			if (binding.value && binding.value !== binding.oldValue) {
				el.src = binding.value;
			}
		},
	});
});
